import { ComponentInternalInstance, computed, getCurrentInstance, reactive, ref } from '@vue/composition-api';
import dayjs from 'dayjs';
import { UploadFile } from 'tdesign-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import getRequest from '@/renderer/scripts/httpRequest';
export interface LogoCallBack {
  afterUploadCOS: (
    logoSrc: string,
    fileInfo: {
      name: string;
      size: number;
    },
  ) => void;
}

/**
 * 企业后台管理的表单验证
 */
export const formHandler = () => {
  /**
   * logo处理器
   */
  const logoUploadHandler = (callback: LogoCallBack) => {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const defaultOrgLogo = computed(() => vm.$store.getters.orgLogo);
    const resPath = ref('');
    const logoInfo = reactive({
      name: '',
      size: '',
      time: '',
    });
    const orgLogo = ref('');
    const fileTypeError = ref(false);
    const fileSizeError = ref(false);
    const files = ref([]);
    const selectedFile = ref(false);
    const uploading = ref(false);
    const uploadComp = ref(null);
    // 是否使用的是默认logo
    const isUsingDefaultLogo = computed(() => orgLogo.value === vm.$store.getters.defaultLogo);
    const methods = {
      /**
       * 上传前
       * @param f
       */
      beforeUpload(f: UploadFile) {
        let result;
        fileTypeError.value = false;
        fileSizeError.value = false;
        const filename = f.name as string;
        const filesize = f.size as number;
        const filetype = f.type as string;
        const lastIndex = filename.lastIndexOf('.');
        if (lastIndex < 0) {
          fileTypeError.value = true;
          return false;
        }
        const imageType = filename.slice(lastIndex + 1).toLowerCase();
        if (!filetype.includes('image') || !['png', 'jpg', 'jpeg'].includes(imageType)) {
          fileTypeError.value = true;
          return false;
        }
        if (filesize > 5 * 1024 * 1024) {
          fileSizeError.value = true;
          return false;
        }
        const reads = new FileReader();
        let tempLogoSrc = '';
        reads.readAsDataURL(f.raw as File);
        reads.onload = async (e: Event) => {
          uploading.value = true;
          tips.loading(i18n_t('正在上传图片'));
          tempLogoSrc = (e.target as any).result;
          reads.readAsArrayBuffer(f.raw as File);
          reads.onload = async (e: Event) => {
            try {
              const res = await smh.userAPI.putOrgLogo({
                ext: imageType,
              });
              const { domain, headers, path } = res.data;
              const body = (e.target as any).result;
              resPath.value = path.startsWith('/') ? path.slice(1) : path;
              const cosRequest = getRequest({
                logPrefix: 'Upload LOGO',
              });
              try {
                await cosRequest({
                  url: `${vm.$store.getters.protocol}://${domain}/${encodeURI(resPath.value)}`,
                  method: 'PUT',
                  headers,
                  data: body,
                });
                selectedFile.value = true;
                orgLogo.value = tempLogoSrc;
                logoInfo.name = f.name as string;
                logoInfo.size = (filesize / 1000).toFixed(2);
                logoInfo.time = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
                callback.afterUploadCOS(tempLogoSrc, {
                  name: filename,
                  size: filesize,
                });
                uploading.value = false;
                result = true;
              } catch (e) {
                selectedFile.value = false;
                uploading.value = false;
                result = false;
                tips.error(e as MsgError);
              }
            } catch (e) {
              tips.error(e as MsgError);
            }
          };
        };
        return result;
      },
      /**
       * 取消上传
       */
      cancelUpload() {
        fileTypeError.value = false;
        fileSizeError.value = false;
        (uploadComp as any).value.cancelUpload();
        orgLogo.value = defaultOrgLogo.value;
        selectedFile.value = false;
      },
    };
    return {
      uploadComp,
      files,
      uploading,
      selectedFile,
      orgLogo,
      fileTypeError,
      fileSizeError,
      resPath,
      logoInfo,
      isUsingDefaultLogo,
      methods,
    };
  };
  return {
    logoUploadHandler,
  };
};
